import { getCurrentInstance } from 'vue';

interface FileUploaderRef {
  filesAdded: (files: File[]) => void;
}

export interface UseFilePastedToEditorOptions {
  uploaderRefName?: string;
}

export const useFilePastedToEditor = (options: UseFilePastedToEditorOptions = {}) => {
  const { proxy } = getCurrentInstance();
  const uploaderRefName = options.uploaderRefName ?? 'uploaderFiles';

  const onFilePastedToEditor = (files: File[] | null | undefined) => {
    const uploader = proxy.$refs[uploaderRefName] as unknown as FileUploaderRef | null | undefined;
    if (uploader == null || files == null || files.length === 0) {
      return;
    }
    uploader.filesAdded(files);
  };

  return { onFilePastedToEditor };
};
